import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { formatCurrency } from '../../utils/formatters';

const SectionHeader = ({ title }) => (
  <Box display="flex" alignItems="center" mb={2}>
    <AccountBalanceIcon color="primary" sx={{ mr: 1 }} />
    <Typography variant="h6">{title}</Typography>
  </Box>
);

const MarginDisbursementSection = ({ order }) => {
  if (!order) return null;

  const taxCalculation = order.latest_tax_calculation || {};
  const exchangeRate = taxCalculation.exchange_rate_dollar_to_real || 1;

  const margemBrl = taxCalculation.margem_comercial_brl;
  const margemUsd = taxCalculation.margem_comercial_usd;

  const acessoriaBrl = taxCalculation.acessoria;
  const acessoriaUsd = acessoriaBrl ? acessoriaBrl / exchangeRate : undefined;
  const showAcessoria = acessoriaBrl > 0;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <SectionHeader title="MARGIN & DISBURSEMENT" />
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell align="right">BRL</TableCell>
                <TableCell align="right">USD</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">
                  Commercial Agreement (Acordo)
                </TableCell>
                <TableCell align="right" sx={{ color: 'error.main' }}>
                  ({formatCurrency(Math.abs(margemBrl || 0), 'BRL')})
                </TableCell>
                <TableCell align="right" sx={{ color: 'error.main' }}>
                  ({formatCurrency(Math.abs(margemUsd || 0), 'USD')})
                </TableCell>
              </TableRow>
              {showAcessoria && (
                <TableRow>
                  <TableCell component="th" scope="row">
                    Advisory Fee (Assessoria)
                  </TableCell>
                  <TableCell align="right">{formatCurrency(acessoriaBrl, 'BRL')}</TableCell>
                  <TableCell align="right">{formatCurrency(acessoriaUsd, 'USD')}</TableCell>
                </TableRow>
              )}
              <TableRow sx={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}>
                <TableCell component="th" scope="row">
                  <Typography fontWeight="bold">Total Disbursement</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.desembolso_total_brl)}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.desembolso_total_usd, 'USD')}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default MarginDisbursementSection;
